// extracted by mini-css-extract-plugin
module.exports = {"card":"CountryCard_card__32aOl","img":"CountryCard_img___aAAX","info":"CountryCard_info__A9yUG","link":"CountryCard_link__2q7QP"};